import React, { useState } from 'react';
import { heroImageBackgroundPosition, normalizeHeroImageFocal } from '../heroImageFocal';

/** Split editorial hero — solid cream copy column + single showcase photo (no carousel). */
export default function HomeEditorialHero({ slide, copyPanel, className = '', onImageReady }) {
  const [ready, setReady] = useState(false);
  const hasImage = Boolean(slide?.src);
  const focal = normalizeHeroImageFocal({ x: slide?.focal_x, y: slide?.focal_y });
  const pos = heroImageBackgroundPosition(focal);

  const markReady = () => {
    setReady(true);
    onImageReady?.(true);
  };

  return (
    <section
      className={`home-hero home-hero--editorial home-hero--editorial-split${hasImage ? ' home-hero--editorial-has-media' : ''}${ready ? ' home-hero--ready' : ''}${className ? ` ${className}` : ''}`.trim()}
      aria-label="Welcome"
    >
      <div className="home-hero__split-grid">
        <div className="home-hero__split-copy">{copyPanel}</div>

        {hasImage ? (
          <div className="home-hero__split-media" aria-hidden="true">
            <img
              className="home-hero__split-img"
              src={slide.src}
              alt={slide.alt || ''}
              style={{ objectPosition: pos }}
              loading="eager"
              decoding="async"
              fetchPriority="high"
              onLoad={markReady}
              onError={markReady}
            />
            <div className="home-hero__split-media-grade" aria-hidden="true" />
            <div className="home-hero__split-media-glow" aria-hidden="true" />
          </div>
        ) : (
          <div className="home-hero__split-media home-hero__split-media--placeholder" aria-hidden="true" />
        )}
      </div>
      {/* Single full-width fade overlay — no column seam */}
      <div className="home-hero__split-fade" aria-hidden="true" />
    </section>
  );
}
